/**
 * ヘッダー全体にクラス名「js-gnav」
 * ヘッダーメニューにクラス名「js-gnav-navbar」
 * ハンバーガーメニューにクラス名「js-gnav-toggle」
 * グローバルメニューにクラス名「js-gnav-menu」
 */

(function($){
  $(function(){
    var $root   = $('.l-header-2025__nav__pc__main__bottom');
    if(!$root.length) return;

    var selLi   = '.l-header-2025__nav__pc__parent > li';
    var selA    = '.l-header-2025__nav__pc__parent > li > a';
    var selBody = '.l-header-2025__nav__pc__parent > li .l-header-2025__nav__pc__body';

    var dur = 300;         // フェード時間
    var openDelay  = 60;   // 開く遅延
    var closeDelay = 220;  // 閉じる遅延（ギャップ対策）
    var closeOthersDur = 120;

    function cancelTimers($li){
      var ht = $li.data('hideTimer'), st = $li.data('showTimer');
      if(ht){ clearTimeout(ht); $li.removeData('hideTimer'); }
      if(st){ clearTimeout(st); $li.removeData('showTimer'); }
    }

    function closeBody($li, fast){
      cancelTimers($li);
      $li.data('isClosing', true);          // ★ 閉じ中フラグON
      var $body = $li.children('.l-header-2025__nav__pc__body');
      // 進行中の「表示アニメ」だけ止めたいが、閉じは継続したい → stop(true,false)で現在を止める
      $body.stop(true, false).animate({opacity:0}, fast ? closeOthersDur : dur, function(){
        $body.css('visibility','hidden');
        $li.removeData('isClosing');        // ★ 完全に閉じ終わってから解除
        $li.removeData('enteredBody');
      });
    }

    function closeOthers($currentLi){
      $root.find(selLi).not($currentLi).each(function(){
        var $x = $(this);
        cancelTimers($x);
        closeBody($x, true);
      });
    }

    function showBody($li){
      // ★ 閉じ中は復帰させない
      if($li.data('isClosing')) return;

      cancelTimers($li);
      var $body = $li.children('.l-header-2025__nav__pc__body');
      var st = setTimeout(function(){
        // show 時のみ stop する（閉じ中はここに来ない）
        $body.stop(true, false).css('visibility','visible').animate({opacity:1}, dur);
      }, openDelay);
      $li.data('showTimer', st);
    }

    function hideBodyLater($li){
      cancelTimers($li);
      var ht = setTimeout(function(){
        closeBody($li, false);
      }, closeDelay);
      $li.data('hideTimer', ht);
    }

    // a に入ったら：他を閉じて自分を開く
    $root.on('mouseenter', selA, function(){
      var $li = $(this).closest(selLi);
      closeOthers($li);
      // a に入った時点では「body未訪問」。ただし閉じ中なら開かない。
      $li.removeData('enteredBody');
      showBody($li);
    });

    // a から出た：body 未訪問なら閉じない／訪問済みなら遅延で閉じる
    $root.on('mouseleave', selA, function(){
      var $li = $(this).closest(selLi);
      if($li.data('enteredBody')) hideBodyLater($li);
      // 未訪問のあいだは表示維持
    });

    // body に入った：表示維持。閉じ中なら無視（復帰させない）
    $root.on('mouseenter', selBody, function(){
      var $li = $(this).closest(selLi);
      if($li.data('isClosing')) return; // ★ フェードアウト開始後の再入は無視
      $li.data('enteredBody', true);
      showBody($li);
    });

    // body から出た：遅延で閉じる（この瞬間から isClosing=true → 再入しても復帰しない）
    $root.on('mouseleave', selBody, function(){
      var $li = $(this).closest(selLi);
      $li.data('enteredBody', true);
      hideBodyLater($li);
    });
  });
})(jQuery);


jQuery(function ($) {
    // ===========================
    // スマホメニューの切り替え
    // ===========================
	var gnavWrapperClass = $('.js-gnav'); // ナビゲーション全体を囲んでいるクラス名
	var gnavToggleClass = $('.js-gnav-toggle'); // トグルメニューのクラス名
	var gnavNavClass = $('.js-gnav-nav'); // ナビバーを囲んでいるクラス名
	var activeClass = 'is-active'; // アクティブ時のクラス名

	function SPmenuOpen() {
		gnavWrapperClass.toggleClass(activeClass);

		if($(gnavWrapperClass).hasClass(activeClass)) {
			gnavToggleClass.addClass(activeClass);
			gnavNavClass.addClass(activeClass);
		} else {
			gnavToggleClass.removeClass(activeClass);
			gnavNavClass.removeClass(activeClass);
		}
	}

    $('.js-gnav-toggle, .l-header-2025-nav--sp__close').on('click', function () {
        SPmenuOpen();
      });

        $(document).on('click', function(e) {
            if(!$(e.target).closest('.js-gnav-navbar').length && $(gnavWrapperClass).hasClass(activeClass)){
                SPmenuOpen();
            }
        });

        var gnavMenuClass = $('.l-header-2025__nav__sp'); // メニューのクラス
        var gnavHasSubmenuClass = '.menu-item-has-children'; // サブメニューを持っている親クラス
        var activeClass = 'is-active';

        if (window.matchMedia('(min-width: 1200px)').matches) {

        // hover状態の制御
        gnavMenuClass.find(gnavHasSubmenuClass).on('mouseenter', function () {
            $(this).addClass(activeClass);
        }).on('mouseleave', function () {
            $(this).removeClass(activeClass);
        });

    }

    // .no-img, .no-link の aタグはリンク無効化
    $('.l-header-2025 a.no-link').on('click', function(e) {
        e.preventDefault();
    });
});
// ===========================
// スマホのサブメニューのアコーディオン開閉（スムーズ & padding制御）
// ===========================
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.l-header-2025__nav__sp')
  if (!root) return

  const items = root.querySelectorAll('.l-header-2025__nav__sp__parent > li')
  const DURATION = 250
  const EASE = 'ease'
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  // --- ユーティリティ ---
  const isBusy = el => el.dataset.animating === '1'
  const lock = el => { el.dataset.animating = '1' }
  const unlock = el => { delete el.dataset.animating }

  // 要素の「CSSで定義された padding を反映したときの scrollHeight」を取得
  const measureFullHeightWithCssPadding = el => {
    // 現在のインライン指定を退避
    const prevPadding = el.style.padding
    const prevHeight  = el.style.height
    const prevDisplay = el.style.display
    const prevOverflow = el.style.overflow
    const prevTransition = el.style.transition

    // 計測のための一時設定（CSS優先のpadding & 自然高さ）
    el.style.transition = 'none'
    el.style.display = 'block'
    el.style.overflow = 'hidden'
    el.style.height = 'auto'
    el.style.padding = '' // インラインを消す→CSS側のpaddingが有効

    const h = el.scrollHeight

    // 元に戻す
    el.style.padding = prevPadding
    el.style.height = prevHeight
    el.style.display = prevDisplay
    el.style.overflow = prevOverflow
    el.style.transition = prevTransition

    return h
  }

  // --- 開く ---
  const slideDown = el => {
    if (isBusy(el)) return
    lock(el)

    if (reduceMotion) {
      // 動きを減らす設定：即時反映（CSS優先のpaddingへ）
      el.style.display = 'block'
      el.style.height = 'auto'
      el.style.padding = '' // CSS側のpaddingに委ねる
      el.style.overflow = 'visible'
    } else {
      el.style.display = 'block'
      el.style.overflow = 'hidden'

      // 目標高さ（CSSのpadding込み）を事前計測
      const target = measureFullHeightWithCssPadding(el)

      // アニメ開始値（paddingは0を維持して高さだけで演出）
      el.style.transition = 'none'
      el.style.padding = '0px'
      el.style.height = '0px'

      // 次フレームで目標へ
      requestAnimationFrame(() => {
        el.style.transition = `height ${DURATION}ms ${EASE}`
        el.style.height = `${target}px`
      })

      const onEnd = e => {
        if (e.propertyName !== 'height') return
        el.removeEventListener('transitionend', onEnd)
        // アニメ終了：高さはautoに、paddingはインライン指定を消してCSS優先
        el.style.transition = ''
        el.style.height = 'auto'
        el.style.padding = '' // ← これでCSSのpaddingが有効になる
        el.style.overflow = 'visible'
        unlock(el)
      }
      el.addEventListener('transitionend', onEnd)
    }
  }

  // --- 閉じる ---
  const slideUp = el => {
    if (isBusy(el)) return
    lock(el)

    if (reduceMotion) {
      el.style.transition = ''
      el.style.overflow = 'hidden'
      el.style.height = '0px'
      el.style.padding = '0px' // 閉じ状態はpadding:0（インラインで固定）
      unlock(el)
    } else {
      // 開いている現状（CSS padding + auto高さ）から現在高さを確定
      const startH = el.getBoundingClientRect().height

      el.style.transition = 'none'
      el.style.overflow = 'hidden'
      el.style.height = `${startH}px`
      // 閉じアニメでは padding を 0 に戻す（高さと同時に縮む演出を避けたい場合は先に0へ）
      // ただし「ガクッ」を避けるため、高さのみでアニメし、paddingは先に0へしておく
      el.style.padding = '0px'

      requestAnimationFrame(() => {
        el.style.transition = `height ${DURATION}ms ${EASE}`
        el.style.height = '0px'
      })

      const onEnd = e => {
        if (e.propertyName !== 'height') return
        el.removeEventListener('transitionend', onEnd)
        el.style.transition = ''
        // display は block のままでOK（height:0 & overflow:hidden で非表示相当）
        unlock(el)
      }
      el.addEventListener('transitionend', onEnd)
    }
  }

  // --- 初期化：すべて閉じる（paddingは0、heightは0） ---
  items.forEach(li => {
    const body = li.querySelector('.l-header-2025__nav__sp__body')
    if (!body) return
    body.style.display = 'block'
    body.style.height = '0px'
    body.style.overflow = 'hidden'
    body.style.padding = '0px' // 初期は0（インライン指定で固定）
    body.setAttribute('aria-hidden', 'true')
    li.setAttribute('aria-expanded', 'false')
  })

  // --- クリック設定 ---
  items.forEach(li => {
    li.addEventListener('click', e => {
      // aタグ（または子孫）をクリックした場合は通常遷移
      if (e.target.closest('a')) return

      const body = li.querySelector('.l-header-2025__nav__sp__body')
      if (!body || isBusy(body)) return

      const opened = body.getBoundingClientRect().height > 0

      if (opened) {
        slideUp(body)
        body.setAttribute('aria-hidden', 'true')
        li.setAttribute('aria-expanded', 'false')
        return
      }

      // 他を閉じる（アコーディオン：単一展開）
      items.forEach(other => {
        if (other === li) return
        const ob = other.querySelector('.l-header-2025__nav__sp__body')
        if (!ob || isBusy(ob)) return
        if (ob.getBoundingClientRect().height > 0) {
          slideUp(ob)
          ob.setAttribute('aria-hidden', 'true')
          other.setAttribute('aria-expanded', 'false')
        }
      })

      // 自分を開く
      slideDown(body)
      body.setAttribute('aria-hidden', 'false')
      li.setAttribute('aria-expanded', 'true')
    })
  })
})
